import Util from "@/helper/Utility.js";
/**
 * @exports SupplementaryModel
 * @exports SupplementaryModelBuilder
*/
export function SupplementaryModel() {
    this.mainPersonalId = null;
    this.childPersonalId = null;
    this.getParams = function () {
        let data = {
            main_perosnalid: this.mainPersonalId,
            child_personalid: this.childPersonalId,
        };
        return Util.cleanObjectEmptyStr(data);
    }
}

export function SupplementaryModelBuilder() {
    this.supplementaryModel = new SupplementaryModel();

    this.create = () => {
        return this.supplementaryModel;
    }

    this.setMainPersonalId = (mainPersonalId) => {
        this.supplementaryModel.mainPersonalId = mainPersonalId;
        return this;
    }

    this.setChildPersonalId = (childPersonalId) => {
        this.supplementaryModel.childPersonalId = childPersonalId;
        return this;
    }
}

